import { submissionSchema } from './../../../../../server/api/submission/model/submission-model';
import {IUserResource} from "../../core/services/UserService";
import {IMinistryResource} from "../../core/services/MinistryService";
import {IAgencyResource} from "../../core/services/AgencyService";
import * as swal from "sweetalert";
import * as _ from "lodash";
export class UserModalComponent implements ng.IComponentOptions {
  public controller: any = UserModalController;
  public bindings: any = {
    modalInstance: "<",
    resolve: "<"
  }
  public template: string = /*html*/`
    <div class="modal-header">
      <button type="button" class="close" ng-click="$ctrl.cancel()" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      <h4 class="modal-title" id="userModal">Add User</h4>
    </div>
    <div class="modal-body">
      <form name="userForm" class="form-horizontal">
        <div class="form-group">
          <label for="fullName" class="col-sm-3 control-label">Full Name</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="fullName" placeholder="Full Name" ng-model="$ctrl.form.fullname" required>
          </div>
        </div>
        <div class="form-group">
          <label for="email" class="col-sm-3 control-label">Email</label>
          <div class="col-sm-9">
            <input type="email" class="form-control" id="email" placeholder="Email" ng-model="$ctrl.form.email" required>
          </div>
        </div>
        <div class="form-group">
          <label for="contact" class="col-sm-3 control-label">Contact No</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="contact" placeholder="Contact No" ng-model="$ctrl.form.contact">
          </div>
        </div>
        <div class="form-group">
          <label for="isMinistry" class="col-sm-3 control-label">Ministry User</label>
          <div class="col-sm-9">
            <label class="radio-inline">
              <input name="isMinistry" ng-model="$ctrl.form.is_ministry" type="radio" ng-value="true"/> Yes
            </label>
            <label  class="radio-inline">
              <input name="isMinistry" ng-model="$ctrl.form.is_ministry" type="radio" ng-value="false"/> No
            </label>
          </div>
        </div>
        <div class="form-group">
          <label for="ministry" class="col-sm-3 control-label">Ministry</label>
          <div class="col-sm-9">
            <ui-select ng-model="$ctrl.form.ministry" required name="ministry">
              <ui-select-match placeholder="Select Ministry">
                <span ng-bind="$select.selected.display_name"></span>
              </ui-select-match>
              <ui-select-choices repeat="item in ($ctrl.ministries | filter: $select.search)">
                <span ng-bind="item.display_name"></span>
              </ui-select-choices>
            </ui-select>
          </div>
        </div>
        <div class="form-group" ng-if="!$ctrl.form.is_ministry">
          <label for="agency" class="col-sm-3 control-label">Agency</label>
          <div class="col-sm-9">
            <ui-select ng-model="$ctrl.form.agency" required name="agency">
              <ui-select-match placeholder="Select Agency">
                <span ng-bind="$select.selected.display_name"></span>
              </ui-select-match>
              <ui-select-choices repeat="item in ($ctrl.form.ministry.agencies | filter: $select.search)">
                <span ng-bind="item.display_name"></span>
              </ui-select-choices>
            </ui-select>
          </div>
        </div>
        <div class="form-group">
          <label for="division" class="col-sm-3 control-label">Division</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="division" placeholder="Division" ng-model="$ctrl.form.division">
          </div>
        </div>
        <div class="form-group">
          <label for="desc" class="col-sm-3 control-label">Description</label>
          <div class="col-sm-9">
            <textarea class="form-control" id="desc" placeholder="Description" ng-model="$ctrl.form.description" required></textarea>
          </div>
        </div>
        <div class="form-group">
          <label for="division" class="col-sm-3 control-label">Password</label>
          <div class="col-sm-9">
            <input type="password" class="form-control" id="division" placeholder="Password" ng-model="$ctrl.form.password">
            <span>Makesure you have copied the password to somewhere</span>
          </div>
        </div>
        <div class="checkbox">
          <label>
            <input type="checkbox" ng-model="$ctrl.form.subscribe"> Notify me when there are new published statistics
          </label>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()">Close</button>
      <button type="button" class="btn btn-primary" ng-click="userForm.$valid && $ctrl.saveUser()">Save changes</button>
    </div>`;
}
export interface IUser extends ng.resource.IResource<any> {

}
export class UserModalController {
  public static $inject: Array<string> = ["UserService", "MinistryService", "$timeout"];
  public modalInstance: ng.ui.bootstrap.IModalServiceInstance;
  public resolve: any;
  public form:any;
  public ministries: Array<any>;
  public isEdit: boolean;
  constructor(private UserService: IUserResource, private MinistryService: IMinistryResource, private $timeout: ng.ITimeoutService){
    this.ministries = MinistryService.query({state: "active", allFields: true});
    $timeout(() => {
      if (this.resolve && this.resolve.user) {
        this.isEdit = true;
        this.form = this.resolve.user;
        this.form.subscribe = this.form.subscription && this.form.subscription.indexOf('published') > -1
        this.ministries.$promise.then(() => {
          this.form.ministry = _.find(this.ministries, {_id: this.form.ministry._id});
        })
      }
      else {
        this.isEdit = false;
      }
    })
  }
  public cancel() {
    this.modalInstance.dismiss("canceled");
  }
  public saveUser() {
    if (this.form.is_ministry)
      this.form.agency = null;
    if (this.form.subscribe && (this.form.subscription && this.form.subscription.indexOf('published') === -1 || !this.form.subscription)) {
      if (!this.form.subscription)
        this.form.subscription = []
      this.form.subscription.push("published")
    }
    else {
      this.form.subscription = _.pull(this.form.subscription, 'published')
    }
    if (this.isEdit) {
      this.UserService.update({userId: this.form._id}, this.form)
      .$promise.then((saved) => {
        saved.ministry = this.form.ministry;
        saved.agency = this.form.agency;
        this.modalInstance.close(saved);
      })
      .catch((e) => {
        if (e.code === 100)
          swal('Sorry', 'User already exists. Please Check again', 'warning')
        else 
          swal("Oops!","User failed to update. Please try again", "warning");
      })
    }
    else {
      this.form.usertype = "internal";
      let _user: IUser = new this.UserService(this.form);
      _user.$save().then((saved) => {
        saved.ministry = this.form.ministry;
        saved.agency = this.form.agency;
        this.modalInstance.close(saved);
      })
      .catch(() => {
        swal("Oops!", "User failed to save, please try again", "warning");
      })
    }
  }
}
